<template>
  <el-upload class="upload-demo" :action="action" :on-preview="onPreview" :on-remove="handleRemove"
    :before-remove="beforeRemove" multiple :limit="5" :on-exceed="handleExceed" :file-list="fileList"
    :before-upload="beforeUpload" :on-success="handleSuccess" :class="`upload-disabled-${disabled}`"
    :disabled="disabled" accept="*">
    <template v-if="!disabled">
      <el-button class="upload-btn">选择文件</el-button>
      <div slot="tip" class="el-upload__tip">
        <p class="upload-text">请上传您项目的相关资料，以便我们能更清楚的了解您的需求。</p>
        <p class="upload-text"> 至多上传5个文件，单个文件不超过20M。</p>
      </div>
    </template>
  </el-upload>
</template>
<script>
export default {
  name: 'LsUpload',
  model: {
    prop: "value",
    event: "change"
  },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      action: "ajaxApi/index.php?s=App.FileUpload.Upload",
      fileList: [],
      update: false,
      baseURL: '',
      isOverSize: false,
      status: 'none'
    }
  },

  mounted () {
    let baseAction = 'ajaxApi/index.php?s=App.FileUpload.Upload'
    if (location.origin.includes('test')) {
      this.baseURL = 'https://testnsrc.databeehub.cn/'
    } else {
      this.baseURL = 'https://nsrc.databeehub.cn/'
    }
    this.action = (process.env.NODE_ENV == 'development' ? '/' : this.baseURL) + baseAction

    if (this.value) {
      this.fileList = this.value
    }
  },
  methods: {
    handleRemove (file, fileList) {
      this.handleUpdateFiles(fileList)
    },
    handlePreview (file) {
      console.log(file);
    },
    handleExceed (files, fileList) {
      this.$message.warning(`当前限制选择5个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
    beforeRemove (file, fileList) {
      return new Promise((resolve, reject) => {
        resolve()
      })
    },
    beforeUpload (file) {
      const isLt20M = file.size / 1024 / 1024 < 20;
      if (!isLt20M) {
        this.isOverSize = true
        this.$message.error("上传文件大小不能超过 20MB!");
        return false;
      }
      this.status = 'pending'
      return true;
    },
    handleSuccess (response, file, fileList) {
      this.fileList = fileList;
      const { ret, msg } = response;
      if (ret === 200) {
        this.status = 'done'
        this.handleUpdateFiles(fileList)
      } else {
        this.fileList.splice(this.fileList.length - 1, 1);
        this.$message.error(file.name + "上传失败：" + msg);
      }
    },
    onPreview (file) {
      if (file.path) {
        const url = `${process.env.NODE_ENV == 'development' ? '/' : this.baseURL}ajaxApi/index.php?s=App.FileUpload.DownFile&file_path=${file.path}&real_name=${file.name}`
        let iframe = document.createElement("iframe");
        iframe.src = url;
        iframe.style.display = "none";
        document.body.appendChild(iframe);
      } else {
        this.$message.warning(file.name + '上传未完成,不能下载!');
      }
    },
    handleUpdateFiles (fileList) {
      this.update = true
      const files = []
      fileList.forEach(item => {
        let file = item
        if (item.response && item.response.data) {
          let data = item.response.data
          file = {
            name: data.showName,
            path: data.dbPath
          }
        }
        files.push({ ...file });
      })
      this.$emit('change', files)
    }
  },
  watch: {
    value () {
      if (!this.value || this.value.length == 0) {
        this.fileList = [];
      } else {
        //只给外部初始化时回填,为内部触发change时不回填
        if (!this.update) {
          this.fileList = [];
          for (let i = 0; i < this.value.length; i++) {
            this.fileList.push({
              ...this.value[i]
            });
          }
        }
      }
    }
  }
}
</script>
<style lang="less">
.el-icon-upload-success {
  color: #FCAE07;
}

.upload-disabled-true .el-upload,
.upload-disabled-true .el-upload-list__item-status-label {
  display: none !important;
}

.el-progress__text{
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/components/LsUpload.vue